import React from 'react';
import { observer, Provider } from 'mobx-react';
import './app.less';
import {
    DatePicker,
    Icon,
    Row,
    Col
} from 'antd';
import { action, toJS } from 'mobx';
import store from './store';
import China from './components/china';
import List from './components/list';
import Line from './components/line';
import Pie from './components/pie';
import U from './actions'



@observer
class App extends React.Component {
    render() {
        const data = toJS(store)
        console.log(data)
        return <Provider store={store}>
            <div className='bodyBox'>
                <div className="top">
                    <div className="title1">
                        上海工程技术大学{data.nowYear}级迎新数据展示
                    </div>
                    <div className='titme'>
                        <DatePicker
                            suffixIcon={<Icon type="down" />}
                            allowClear={false}
                            value={data.selectedDate}
                            onChange={(date) => {//moment对象
                                store.selectedDate = date
                                const time = date.format("YYYY-MM-DD")
                                U.getTimeStatics(1, time)
                                U.getTimeStatics(2, time)
                            }}
                        />
                    </div>
                </div>
                <div className="bottom">
                    <div className='bottom_left'>
                        <div className='bottom_left_top large'>
                            <div className="title2">
                                各学院报到情况
                            </div>
                            <div onClick={() => {
                                this.changeStuType('selectedAcademyStuType', 0)
                            }} className={data.selectedAcademyStuType * 1 === 0 ? 'leftBtn active' : "leftBtn"}>本专科生</div>
                            <div onClick={() => {
                                this.changeStuType('selectedAcademyStuType', 1)
                            }} className={data.selectedAcademyStuType * 1 === 1 ? 'rightBtn active' : "rightBtn"}>研究生</div>
                            <div className='tableList'>
                                <List
                                    sort={false}
                                    columns={
                                        [{
                                            name: "学院名称",
                                            dataIndex: "name",
                                            align: "left"
                                        },
                                        {
                                            name: "已报到人数",
                                            dataIndex: "arrived"
                                        },
                                        {
                                            name: "应报到人数",
                                            dataIndex: "shouldArrive"
                                        },
                                        {
                                            name: "报到率",
                                            render: (val, row, index) => {
                                                console.log(row)
                                                if (row.shouldArrive * 1 === 0) {
                                                    return '100%'
                                                }
                                                return ((row.arrived / row.shouldArrive * 100) || 0).toFixed(2) + "%"
                                            }
                                        }]
                                    }
                                    dataSource={data.selectedAcademyStuType * 1 === 0 ? data.undergraduateAcademy : data.postgraduateAcademy}
                                />
                            </div>
                        </div>
                        {/* <div className='bottom_left_bottom'>
                            <div className="title2">
                                留学生报到情况
                                
                            </div>
                            <div className='legend'>
                                    <div><span className='point'></span>已报到</div>
                                    <div><span className='point noarr'></span>未报到</div>
                                </div>
                                    <Pie data={[{
                                        label: `${data.international.arrived}人`,
                                        value:data.international.arrived,
                                        name: '已报到'
                                    },
                                    {
                                        label: `${data.international.shouldArrive - data.international.arrived}人`,
                                        value: data.international.shouldArrive - data.international.arrived,
                                        name: '未报到'
                                    }]} />
                        </div> */}
                    </div>
                    <div className='bottom_center'>
                        <div className="bottom_center_top">
                            <China data={this.tochinaData(data.province)} />
                            <div className='visualMap'>
                                <div className='chinaTitle'>
                                    报到人数占比
                                </div>
                                <div className='jianbian'>

                                </div>
                                <div className='di'>
                                    低
                                </div>
                                <div className='gao'>
                                    高
                                </div>
                            </div>

                            <div className='posi'>
                                <div className='alltongji'>
                                    <Row>
                                        <Col span={16}>已报到总人数</Col>
                                        <Col span={8}>{data.allArrived}</Col>
                                        <Col span={16}>未报到总人数</Col>
                                        <Col span={8}>{data.allShouldArrive - data.allArrived}</Col>
                                        <Col span={16}>报到率</Col>
                                        <Col span={8}>{((data.allArrived / data.allShouldArrive * 100).toFixed(2) + '%')}</Col>
                                    </Row>
                                </div>
                                <div className='shenList'>
                                    <Row className='title'>
                                        <Col span={8}>省份</Col>
                                        <Col span={8}>已报到</Col>
                                        <Col span={8}>未报到</Col>
                                    </Row>
                                    <ul className="scollBox" ref={(node) => { this.scollNode = node }}>
                                        {this.shenListRender(data.province)}
                                    </ul>

                                </div>
                            </div>
                        </div>
                        <div className="bottom_center_bottom">
                            <div className="title2">
                                整体报到情况
                            </div>
                            <div className='legend'>
                                <div><span className='point'></span>已报到</div>
                                <div><span className='point noarr'></span>未报到</div>
                            </div>

                            <Row>
                                {this.pieRender(data.wholeStatistics)}
                            </Row>
                        </div>
                    </div>
                    <div className='bottom_right'>
                        <div className="bottom_right_top">
                            <div className="title2">
                                按时间段报到情况
                            </div>
                            <div onClick={() => {
                                this.changeStuType('selectedTimeSlotStuType', 0)
                            }} className={data.selectedTimeSlotStuType * 1 === 0 ? 'leftBtn active' : "leftBtn"}>本专科生</div>
                            <div onClick={() => {
                                this.changeStuType('selectedTimeSlotStuType', 1)
                            }} className={data.selectedTimeSlotStuType * 1 === 1 ? 'rightBtn active' : "rightBtn"}>研究生</div>
                            <div className='lineBox'>
                                <Line data={this.toLineData(data.selectedTimeSlotStuType * 1 === 0 ? data.undergraduateTimeSlot : data.postgraduateTimeSlot)} />
                            </div>
                        </div>
                        <div className="bottom_right_bottom">
                            <div className="title2">
                                专业报到TOP10
                            </div>
                            <div onClick={() => {
                                this.changeStuType('selectedTopStuType', 0)
                            }} className={data.selectedTopStuType * 1 === 0 ? 'leftBtn active' : "leftBtn"}>本专科生</div>
                            <div onClick={() => {
                                this.changeStuType('selectedTopStuType', 1)
                            }} className={data.selectedTopStuType * 1 === 1 ? 'rightBtn active' : "rightBtn"}>研究生</div>
                            <div className='tableList'>
                                <List
                                    sort={true}
                                    columns={
                                        [{
                                            name: "专业名称",
                                            dataIndex: "name",
                                        },
                                        {
                                            name: "已报到人数",
                                            dataIndex: "arrived"
                                        },
                                        {
                                            name: "应报到人数",
                                            dataIndex: "shouldArrive"
                                        },
                                        {
                                            name: "报到率",
                                            render: (val, row, index) => {
                                                if (row.shouldArrive * 1 === 0) {
                                                    return '100%'
                                                }
                                                return ((row.arrived / row.shouldArrive * 100) || 0).toFixed(2) + "%"
                                            }
                                        }]
                                    }
                                    dataSource={data.selectedTopStuType * 1 === 0 ? data.undergraduateTop : data.postgraduateTop}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Provider>
    }
    //饼状图统计
    pieRender = (data = []) => {
        const toPieData = (obj) => {//将数据变成饼状图要的数据
            return [{
                label: `${obj.arrived}人`,
                value: obj.arrived,
                name: '已报到'
            },
            {
                label: `${obj.shouldArrive - obj.arrived}人`,
                value: obj.shouldArrive - obj.arrived,
                name: '未报到'
            }]
        }
        return data.map(function (item, index) {
            return <Col key={index} span={parseInt(24 / data.length)}>
                <div>
                    <Pie data={toPieData(item)} />
                    <div className='pieTitle'>{item.name}</div>
                </div>
            </Col>
        })

    }
    @action
    changeStuType = (which, value) => {
        store[which] = value
    }

    toLineData = (data = []) => {//变成折线图要的数据
        const dataarr = [], xname = []
        data.forEach(function (item) {
            dataarr.push(item.arrived)
            xname.push(item.name)
        })
        return {
            data: dataarr,
            xname
        }
    }

    tochinaData = (data = []) => {
        const arr = []
        data.forEach(function (item) {
            const lv = item.arrived / item.shouldArrive * 100 || 0
            arr.push({
                name: item.name,
                value: lv >= 100 ? 100 : lv,
                shouldArrive: item.shouldArrive,
                arrived: item.arrived
            })
        })
        return arr
    }

    shenListRender = (data = []) => {
        const arr = []
        for (const item of data) {
            if(item.name !== '暂无省份'){
                arr.push({...item})
            }
        }
        return arr.map(function (item, index) {
            return <li key={index}>
                <Row>
                    <Col span={8}>{item.name}</Col>
                    <Col span={8}>{item.arrived}人</Col>
                    <Col span={8}>{item.shouldArrive - item.arrived}人</Col>
                </Row>
            </li>
        })
    }
    componentDidMount() {
        const _this = this
        U.getAll()
        setInterval(() => {
            // U.getAll()
            _this.changeAllStuType()//自动切换本科生 研究生
        }, 30000)//每隔30秒切换学生类型
        setInterval(() => {
            U.getAll()
        }, 60000)//每隔一分钟秒刷新数据
        this.loop()
    }
    loop = () => {
        if (this.interVal) {
            return
        }

        const boxDom = this.scollNode
        const scollHeight = this.scollNode.scrollHeight
        const clientHeight = this.scollNode.clientHeight
        if (scollHeight <= clientHeight) {
            return
        }

        let top = true
        this.interVal = setInterval(() => {

            if (top) {
                boxDom.scrollTop += 1
            } else {
                boxDom.scrollTop -= 1
            }

            if (boxDom.clientHeight + boxDom.scrollTop >= boxDom.scrollHeight - 3) {
                setTimeout(() => {
                    top = false
                }, 800);

            }
            if (boxDom.scrollTop <= 0 + 3) {
                setTimeout(() => {
                    top = true
                }, 800);

            }
        }, 50);



    }
    componentDidUpdate() {
        this.loop()
    }
    changeAllStuType = () => {
        const type = !(toJS(store.selectedAcademyStuType) * 1) //本来要取三个type，但是为了页面统一就只取一个
        this.changeStuType('selectedAcademyStuType', type)
        this.changeStuType('selectedTimeSlotStuType', type)
        this.changeStuType('selectedTopStuType', type)
    }
}

export default App

